<template>
  <div>
    <!-- <el-tabs
      v-model="activeTabs"
      type="card"
      @tab-remove="removeTab"
      @tab-click="tabClcik"
      closable
      class="heght"
    >
      <el-tab-pane
        v-for="item in editableTabs"
        :key="item.path"
        :label="item.name"
        :name="item.path"
      >
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 激活当前菜单
      activeTabs: '/user',
      editableTabs: [
        {
          name: '首页',
          path: '/user'
        }
      ]
    }
  },
  watch: {
    $route (to, from) {
      this.getTabs(to)
    }
  },
  mounted () {
    this.getTabs(this.$route)
  },
  methods: {
    // 1.判断数组中是否有重复数据
    // 2.数组的新增
    // 3.设置动态tab 激活
    getTabs (to) {
      const obj = {
        name: to.meta.title,
        path: to.path
      }
      
      const index = this.editableTabs.findIndex(itme => itme.path === obj.path)
      if (index < 0) {
        this.editableTabs.push(obj)
      }
      this.activeTabs = to.path
     
    },
    // 切换tab
    tabClcik (tab) {
      this.$router.push(tab.name)
    },
    // 移除tab
    removeTab (targetName) {
      // tab数组
      const tabs = this.editableTabs
      // 激活tab
      let activeName = this.activeTabs
      // 判断激活的path 是否和删除path相等
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.path === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.path
            }
          }
        })
      }
      this.activeTabs = activeName
      this.$router.push(activeName)
      this.editableTabs = tabs.filter(tab => tab.path !== targetName)
    }
  }
}
</script>

<style lang="scss">
.el-tabs__nav-scroll {
  padding: 2px 0 2px 10px;
  height: 30px;
  border-bottom: 1px solid #d8dce5;
  -webkit-transition: opacity 0.12s ease-out;
  transition: opacity 0.12s ease-out;
}
.el-tabs__header {
  margin: 0;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: none;
}
.el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item {
  height: 26px;
 
  font-size: 12px;
  line-height: 23px;
 
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}
//字体点击颜色

.el-tabs--card > .el-tabs__header .el-tabs__item .el-icon-close {
  position: relative;
  font-size: 12px;
  width: 0;
  height: 14px;
  vertical-align: middle;
  line-height: 13px;
  top: -1px;
  right: -2px;
  transform-origin: 0 0;
  overflow: unset;
}
.el-tabs__item{
  padding: 0 10px;
}
.shouye .el-icon-close:before {
  display: none;
}
.el-tabs--card > .el-tabs__header .el-tabs__item:first-child .el-icon-close {
  display: none;
}
.el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child{
  padding-right: 10px;
}
.el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2){
  padding-left: 10px;
}
.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable{
  padding: 0 10px 0 10px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item .el-icon-close{
  margin-right:10px;
}
</style>
